import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  videoPlayerWrapper: css``,
  videoPlayer: css``,
}));

export const useVideoPlayerStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
